<template>
  <v-navigation-drawer
    v-if="!themeStore.isMobile && !themeStore.hideMenuBar"
    app
    rail
    permanent
    style="position: fixed; top: 64px; z-index: 1000"
  >
    <v-list>
      <v-tooltip location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/manual">
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item>
        </template>
        作業マニュアル
      </v-tooltip>

      <!-- AI 生成（画像 / 動画 / モデル。4 権限のどれかがあれば表示） -->
      <v-tooltip v-if="authStore.canAccessAnyGeneration" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/generate">
            <v-icon>mdi-creation</v-icon>
          </v-list-item>
        </template>
        AI 生成
      </v-tooltip>

      <!-- Chat（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_chat" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/chat">
            <v-icon>mdi-chat-processing-outline</v-icon>
          </v-list-item>
        </template>
        Chat
      </v-tooltip>

      <!-- Analyzer（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_chat" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/analyzer">
            <v-icon>mdi-brain</v-icon>
          </v-list-item>
        </template>
        Analyzer
      </v-tooltip>

      <!-- AI NPC（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_ai_npc" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/ai-npc">
            <v-icon>mdi-robot-happy-outline</v-icon>
          </v-list-item>
        </template>
        AI NPC
      </v-tooltip>

      <!-- DIG 防災マップ（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_dig" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/dig">
            <v-icon>mdi-map-marker-alert</v-icon>
          </v-list-item>
        </template>
        防災マップ (DIG)
      </v-tooltip>

      <!-- Spaces（物理スペース + Garden 管理・権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_spaces" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/spaces">
            <v-icon>mdi-floor-plan</v-icon>
          </v-list-item>
        </template>
        スペース
      </v-tooltip>

      <!-- Okaki（絵を動かす・権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_okaki" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/okaki">
            <v-icon>mdi-draw</v-icon>
          </v-list-item>
        </template>
        Okaki（絵を動かす）
      </v-tooltip>

      <!-- 業務管理（bizhub・権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_bizhub" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/bizhub">
            <v-icon>mdi-briefcase-outline</v-icon>
          </v-list-item>
        </template>
        業務管理
      </v-tooltip>

      <!-- スライド動画（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_slide_video" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/slide-videos">
            <v-icon>mdi-filmstrip-box-multiple</v-icon>
          </v-list-item>
        </template>
        スライド動画
      </v-tooltip>

      <!-- オペレーション画面（権限があるユーザーのみ表示） -->
      <v-tooltip v-if="authStore.userSettings.can_access_operation" location="right">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" link to="/app/operation">
            <v-icon>mdi-television-play</v-icon>
          </v-list-item>
        </template>
        オペレーション画面
      </v-tooltip>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { eventBus } from "@/eventBus"; // ✅ イベントバスをインポート
import { useRoomStore } from "@/stores/roomStore";
import { useThemeStore } from "@/stores/themeStore";
import { useAuthStore } from "@/stores/authStore";

export default {
  setup() {
    const roomStore = useRoomStore();
    const themeStore = useThemeStore();
    const authStore = useAuthStore();

    const resetRoom = () => {
      eventBus.emit("resetRoom"); // ✅ ルームリセットイベントを発火
    };

    return {
      roomStore,
      resetRoom,
      themeStore,
      authStore,
    };
  },
};
</script>
